import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { FullPageLoadingSpinner } from 'shared/components/FullPageLoadingSpinner.tsx';

export const DefaultLayout = () => {
  return (
    <main className="min-h-full-device bg-background flex items-center justify-center p-4 md:p-8">
      <Suspense fallback={<FullPageLoadingSpinner size={48} />}>
        <Outlet />
      </Suspense>
    </main>
  );
};
